
export const PRYPCO_COLUMNS = [
  {
    Header: "Transaction ID",
    Footer: "Transaction ID",
    accessor: "transactionId",
    sticky: "left",
  },
  {
    Header: "IsQualified",
    Footer: "IsQualified",
    accessor: "isQualified",
    sticky: "left",
  },
  {
    Header: "Transaction Type",
    Footer: "Transaction Type",
    accessor: "transactionType",
    sticky: "left",
  },
  {
    Header: "Earning",
    Footer: "Earning",
    accessor: "earning",
    sticky: "left",
  },

  {
    Header: "Total Amount",
    Footer: "Total Amount",
    accessor: "totalAmount",
  },
  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionProcessedDate",
    sticky: "left",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const COLUMNS = [
  {
    Header: "Transaction ID",
    Footer: "Transaction ID",
    accessor: "transactionId",
    sticky: "left",
  },
  {
    Header: "IsQualified",
    Footer: "IsQualified",
    accessor: "isQualified",
    sticky: "left",
  },
  {
    Header: "Transaction Type",
    Footer: "Transaction Type",
    accessor: "transactionType",
    sticky: "left",
  },
  {
    Header: "Earning",
    Footer: "Earning",
    accessor: "earning",
    sticky: "left",
  },

  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionProcessedDate",
    sticky: "left",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];

export const GENCREST_COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: "firstName",
    sticky: "left",
  },
  {
    Header: "Mobile",
    Footer: "Mobile",
    accessor: "mobile",
  },
  {
    Header: "Total Value",
    Footer: "Total Value",
    accessor: "totalAmount",
    sticky: "left",
  },

  {
    Header: "Date",
    Footer: "Date",
    accessor: "transactionDate",
    sticky: "left",
  },
  {
    Header: "UPI Id",
    Footer: "UPI Id",
    accessor: "upiId",
  },
  {
    Header: "UPI Name",
    Footer: "UPI Name",
    accessor: "upiName",
  },
  {
    Header: "Bank Name",
    Footer: "Bank Name",
    accessor: "bankName",
  },
  {
    Header: "Account Number",
    Footer: "Account Number",
    accessor: "accountNumber",
  },
  {
    Header: "IFSC Code",
    Footer: "IFSC Code",
    accessor: "ifscCode",
  },
  {
    Header: "Beneficiary Name",
    Footer: "Beneficiary Name",
    accessor: "beneficiaryName",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];